import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Button from '../../Button'
import Modal from '../index'
import Icon from '../../Icon/Icon'
import css from './style.module.scss'
import { PRELIMINARY_AWARD_APPROVAL } from '../../../constants'

const contactInfo = (
  <div className={css.contactInformation}>
    <div className={css.contactInformationRow}>
      <span><Icon name='email' className={css.contactIcon} /></span>
      <span className={css.contactLabel}>EMAIL:&nbsp;</span>
      <span>  client.services@foundationmedicine.com &nbsp;</span>
      <span className={css.default}>or</span>
    </div>
    <div className={css.contactInformationRow}>
      <span><Icon name='fax' className={css.contactIcon} /></span>
      <span className={css.contactLabel}>FAX:&nbsp;</span>
      <span>  (617) 830-0279</span>
    </div>
  </div>)

export default class OrderModal extends Component {
  static propTypes = {
    handleDismiss: PropTypes.func,
    show: PropTypes.bool,
    padding: PropTypes.string,
    title: PropTypes.string,
    enableAutoFocus: PropTypes.bool,
    handleShown: PropTypes.func,
    handleHidden: PropTypes.func,
    error: PropTypes.bool
  }

  handleOnClick () {
    const { store } = this.props
    store.setFormSubmissionModalDisplay()
    store.cleanData()
  }

  renderSubmittedLanguageBasedOnPreliminary (preliminary, patientName, faaNumber, errorSendingDocuments) {
    const faaSubmittedLanguage = {
      [PRELIMINARY_AWARD_APPROVAL.QUALIFIES_0]: this.qualifies0outOfPocket(patientName, faaNumber, errorSendingDocuments),
      [PRELIMINARY_AWARD_APPROVAL.QUALIFIES_100]: this.qualifies100outOfPocket(patientName, faaNumber, errorSendingDocuments),
      [PRELIMINARY_AWARD_APPROVAL.NO_QUALIFY]: this.doesNotQualify(patientName, faaNumber, errorSendingDocuments),
      [PRELIMINARY_AWARD_APPROVAL.NEEDS_REVIEW]: this.needsReview(patientName, faaNumber, errorSendingDocuments)
    }
    return faaSubmittedLanguage[preliminary]
  }

  qualifies0outOfPocket (patientName, faaNumber, errorSendingDocuments) {
    return (
      <>
        <p>
          Thank you for your application. We are pleased to inform you that your financial assistance application for {patientName} has been submitted and based on the information you provided you qualify for
          an award of no out-of-pocket cost for all Foundation Medicine testing.
          You will receive a confirmation email in your inbox shortly.
        </p>
        <p>
          For your reference, your case number is: {faaNumber}. Please use this number in all future communications. 
        </p>
        <p>
          If you have any questions, please reach out to our Client Services Team at 888.988.3639 or by email at client.services@foundationmedicine.com.
          Applications can take up to 2 business days for processing and you will receive a final determination statement, which you'll receive via the method you selected (email, mail, etc.).
        </p>
        {errorSendingDocuments !== '' &&
          <p>
            {errorSendingDocuments}
          </p>}
      </>
    )
  }

  qualifies100outOfPocket (patientName, faaNumber, errorSendingDocuments) {
    return (
      <>
        <p>
          Thank you for your application. We are pleased to inform you that your financial assistance application for {patientName} has been submitted and based on the information you provided
          your total out-of-pocket cost will be no more than $100 for all Foundation Medicine testing.
          You will receive a confirmation email in your inbox shortly.
        </p>
        <p>
          For your reference, your case number is: {faaNumber}. Please use this number in all future communications. 
        </p>
        <p>
          If you have any questions, please reach out to our Client Services Team at 888.988.3639 or by email at client.services@foundationmedicine.com.
          Applications can take up to 2 business days for processing and you will receive a final determination statement, which you'll receive via the method you selected (email, mail, etc.).
        </p>
        {errorSendingDocuments !== '' &&
          <p>
            {errorSendingDocuments}
          </p>}
      </>
    )
  }

  doesNotQualify (patientName, faaNumber, errorSendingDocuments) {
    return (
      <>
        <p>
          Thank you for your application. After our preliminary review we regret to inform you that your application for {patientName} does not meet
          the eligibility criteria for financial assistance at this time. If your financial situation changes, you are welcome to submit a new application at any time.
          You will receive a confirmation email in your inbox shortly.
        </p>
        <p>
          For your reference, your case number is: {faaNumber}. Please use this number in all future communications. 
        </p>
        <p>
          If you have any questions or would like to better understand this decision, please reach out to our Client Services Team at 888.988.3639 or by email at client.services@foundationmedicine.com.
          Applications can take up to 2 business days for processing. Reasoning for the decision will be included in your final determination statement,
          which you'll receive via the method you selected (email, mail, etc.).
        </p>
        {errorSendingDocuments !== '' &&
          <p>
            {errorSendingDocuments}
          </p>}
      </>
    )
  }

  needsReview (patientName, faaNumber, errorSendingDocuments) {
    return (
      <>
        <p>
          We are pleased to inform you that your financial assistance application for {patientName} has been submitted and you qualify for a preliminary award where
          your total out-of-pocket cost will be no more than $100 for all Foundation Medicine testing. The preliminary award is under review.
          You will receive a confirmation email in your inbox shortly.
        </p>

        <p>
          For your reference, your case number is: {faaNumber}. Please use this number in all future communications.
        </p>

        <p>
          If you have any questions, please reach out to our Client Services Team at 888.988.3639 or by email at client.services@foundationmedicine.com.
          Applications can take up to 2 business days for processing. Once we have reviewed your application further, you will receive a final determination statement,
          which you'll receive via the method you selected (email, mail, etc.).
        </p>

        {errorSendingDocuments !== '' &&
          <p>
            {errorSendingDocuments}
          </p>}
      </>
    )
  }

  renderModalContent () {
    const { success, store: { confirmationNumber, preliminaryAwardApproval, firstName, middleName, lastName, errorSendingDocuments } } = this.props
    if (success) {
      const fullName = `${firstName.value} ${middleName.value} ${lastName.value}`
      return (
        <>
          <div className={css.modalContent}>
            {this.renderSubmittedLanguageBasedOnPreliminary(preliminaryAwardApproval, fullName, confirmationNumber, errorSendingDocuments)}
          </div>
          <div className={css.modalActions}>
            <Button
              onClick={this.handleOnClick.bind(this)}
              data-automation-name='submit-modal-downloadOrder'
              className={classNames(css.modalButton, css.failedModalButton)}
              text='Close'
              name='close'
            />
          </div>
        </>)
    }
    return (
      <>
        <div className={css.modalContent}>
          <p>Due to a system error, your application was not processed successfully.<br /> Try again or re-submit your application by downloading the form and sending to: </p>
          {contactInfo}
          <p>For questions please call Customer Service at <br />1-888-988-3639</p>
        </div>
        <div className={css.modalActions}>
          <form method='get' action='https://info.foundationmedicine.com/hubfs/Online%20Ordering/FinancialAssistanceApplication.pdf' target='_blank'>
            <input type='hidden' name='order' value='value' />
            <Button
              type='submit'
              data-automation-name='submit-modal-downloadOrder'
              className={classNames(css.modalButton, css.failedModalButton)}
              text='Download Application'
              name='downloadOrder'
            />
          </form>
        </div>
      </>)
  }

  static defaultProps = {
    show: false,
    padding: '2.5em',
    enableAutoFocus: true,
    handleShown: () => {},
    handleHidden: () => {},
    error: false
  }

  render () {
    const {
      show,
      store,
      success
    } = this.props

    return (
      <Modal
        title={success ? 'Application Submitted' : 'Failed to submit application'}
        show={show}
        store={store}
        error={!success}
      >
        {this.renderModalContent()}
      </Modal>
    )
  }
}
